import { Action, createReducer, on } from '@ngrx/store';
import { addRecordSuccess, deleteRecordSuccess, loadRecordsSuccess, updateRecordSuccess } from './actions';
import { Category } from '../../../../models/Prodotto';
import {logoutSuccess} from '../../../../core/store/auth/actions';

const initialState: Category[] = null;

const featureReduce = createReducer(
    initialState,
    on(loadRecordsSuccess, (state, {records}) => records),
    on(addRecordSuccess, (state, {record}) => [record, ...state]),
    on(updateRecordSuccess, (state, {record}) => state.map(item => item.id === record.id ? {...item, ...record} : item)),
    on(deleteRecordSuccess, (state, {id}) => state.filter(item => item.id !== id)),
    on(logoutSuccess, () => initialState),
);

export function reducer (state: Category[] | null, action?: Action) {
    return featureReduce(state, action);
}
